module.exports = __webpack_public_path__ + "img/3d-digital-human.15d4817b.png";